(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pp-card-video"] && !Shopify.designMode) return;
  try {
    class PPCardVideo extends HTMLElement {
    static active = null;

    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.gallery = this.closest('.card-gallery');
      if (!this.video || !this.button || !this.gallery || this.listeners) return;
      this.listeners = new AbortController();
      this.requested = false;
      this.requestId = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.hover = matchMedia('(hover: hover) and (pointer: fine)');
      const options = { signal: this.listeners.signal };
      this.video.muted = true;
      this.button.hidden = false;
      this.gallery.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' && this.hover.matches && !this.motion.matches) this.start();
      }, options);
      this.gallery.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') this.stop();
      }, options);
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.requested ? this.stop() : this.start();
      }, options);
      this.gallery.addEventListener('click', () => this.stop(), options);
      this.gallery.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.stop();
      }, options);
      this.gallery.addEventListener('focusout', (event) => {
        if (!this.gallery.contains(event.relatedTarget)) this.stop();
      }, options);
      this.video.addEventListener('playing', () => {
        if (this.requested && !document.hidden) this.setAttribute('data-playing', '');
        else this.stop();
      }, options);
      this.video.addEventListener('pause', () => this.removeAttribute('data-playing'), options);
      this.video.addEventListener('error', () => this.stop(), options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
      }, options);
      this.motion.addEventListener('change', () => this.stop(), options);
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.intersectionRatio < 0.1)) this.stop();
      }, { threshold: 0.1 });
      this.observer.observe(this.gallery);
    }

    async start() {
      if (this.requested || document.hidden || this.closest('[product-grid-view="zoom-out"]')) return;
      if (PPCardVideo.active && PPCardVideo.active !== this) PPCardVideo.active.stop();
      PPCardVideo.active = this;
      this.requested = true;
      const requestId = ++this.requestId;
      this.setAttribute('data-requested', '');
      this.button.setAttribute('aria-label', this.button.dataset.pauseLabel);
      this.video.muted = true;
      try {
        await this.video.play();
        if (!this.requested) this.video.pause();
      } catch {
        if (requestId === this.requestId) this.stop();
      }
    }

    stop() {
      this.requested = false;
      this.requestId += 1;
      this.removeAttribute('data-requested');
      this.removeAttribute('data-playing');
      if (this.video) {
        this.video.pause();
        if (this.video.readyState > 0) this.video.currentTime = 0;
      }
      if (this.button) this.button.setAttribute('aria-label', this.button.dataset.playLabel);
      if (PPCardVideo.active === this) PPCardVideo.active = null;
    }

    disconnectedCallback() {
      this.stop();
      this.listeners?.abort();
      this.listeners = null;
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('pp-card-video')) customElements.define('pp-card-video', PPCardVideo);
  } catch(e) { console.error(e); }
})();

})();
